import { STORAGE_KEY } from '@/api/constants'

export const authStorage = {
  getToken() {
    return localStorage.getItem(STORAGE_KEY.ACCESS_TOKEN)
  },

  setToken(token) {
    if (token) {
      localStorage.setItem(STORAGE_KEY.ACCESS_TOKEN, token)
    } else {
      this.removeToken()
    }
  },

  removeToken() {
    localStorage.removeItem(STORAGE_KEY.ACCESS_TOKEN)
  },

  isAuthenticated() {
    return !!this.getToken()
  }
}

export default authStorage